import { MapTo } from '@adobe/aem-react-editable-components';
import CarouselComponent, { CarouselComponentEditConfig } from './CarouselComponent';

export default MapTo('cob-corp-acquisition/components/creditonebank/carousel-component')(CarouselComponent, CarouselComponentEditConfig);